import { makeStyles } from 'tss-react/mui';
import { ISamparkLayoutStyleProps } from './SamparkLayout.types';

export const useSamparkLayoutStyles = makeStyles<ISamparkLayoutStyleProps>()(
  (theme, { isSideNavExpanded }) => ({
    samparkUi: {
      maxWidth: 2300,
      maxHeight: '100%',
      margin: 'auto'
    },
    samparkLayout: {
      [theme.breakpoints.up(600)]: {
        display: 'grid',
        gridTemplateAreas: `
        'side-nav header-content'
        'side-nav content'
      `,
        gap: '1px',
        transition: '0.2s',
        borderColor: theme.palette.grey[300],
        backgroundColor: theme.palette.background.default,
        padding: '1px',
        justifyContent: 'flex-start',
        // 16rem expanded matches SIDEBAR_WIDTH in sampark-new's Sidebar.
        // The collapsed width stays 88px: the new app uses 3rem, but narrowing
        // it here would require reworking this sidebar's icon layout.
        gridTemplateColumns: isSideNavExpanded ? '16rem 1fr' : '88px 1fr',
        gridTemplateRows: '48px 1fr',
        height: '100vh',
        '& .header': {
          gridArea: 'header-content'
        },
        '& .content-sampark': {
          gridArea: 'content',
          width: '100%'
        },
        '& .sideNav-sampark': {
          gridArea: 'side-nav',
          height: '100%',
          width: '100%',
          // --sidebar-background / --sidebar-border from libs/ui/src/globals.css
          backgroundColor: 'hsl(0, 0%, 98%)',
          borderRight: '1px solid hsl(220, 13%, 91%)',
          boxShadow: 'none'
        }
      },
      [theme.breakpoints.down(600)]: {
        '& .sideNav-sampark': {
          display: 'none'
        }
      }
    }
  })
);

export const useUnderMaintenanceStyles = makeStyles()(() => ({
  underMaintenanceContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '36px'
  }
}));
